import { type FilterValues } from "components/filters/FilterContext";
import { getSortOption } from "components/filters/Filters/FilterTypes/ClientSortFilterType";
import { mapClientAccessFilterToInstruction, mapCountryFilterToInstruction, mapDataClearedToInstruction, mapHubSpotFilterToInstruction, mapKeywordFilterToInstruction, mapPeriodFilterToInstruction, mapResponseToClientAccessFilter, mapResponseToCountriesFilter, mapResponseToDataClearedFilter, mapResponseToHubSpotFilter, mapResponseToKeywordFilter, mapResponseToPeriodFilter } from "components/filters/mappingUtils";


export const mapFilterValuesToInstruction = (
  filterSet: server.dto.FilterSets,
  filter: FilterValues,
  page: number,
  perPage: number
): server.dto.PaginatedClientInstruction => {
  return {
    keyword: mapKeywordFilterToInstruction(filter.keyword),
    countryIds: mapCountryFilterToInstruction(filter.country),
    order: filter.clientSort.sortOption.value,
    clientAccesses: mapClientAccessFilterToInstruction(filter.clientAccess),
    linkedToHubSpot: mapHubSpotFilterToInstruction(filter.hubSpotLinked),
    period: mapPeriodFilterToInstruction(filter.period),
    dataCleared: mapDataClearedToInstruction(filter.dataCleared),
    page,
    perPage,
    cache: filterSet
  };
};

export const mapResponseToFilterValues = (
  response: server.dto.ListClientFilters,
  values: FilterValues
): Partial<FilterValues> => ({
  keyword: mapResponseToKeywordFilter(response.keyword),
  clientAccess: mapResponseToClientAccessFilter(response.clientAccesses, values.clientAccess),
  country: mapResponseToCountriesFilter(response.countryIds),
  hubSpotLinked: mapResponseToHubSpotFilter(response.linkedToHubSpot),
  period: mapResponseToPeriodFilter(response.period),
  dataCleared: mapResponseToDataClearedFilter(response.dataCleared),
  clientSort: {
    sortOption: getSortOption(response.order)
  }
});